import React from 'react';
import styled from 'styled-components';

import { LabledInput } from '@lt/components';
import { i18n } from '@lt/localization';

import type { IPartnerLoyaltyInfo } from '../../../../store/partnerLoyalty/slice';

const INPUT_LABEL = i18n.t('checkout.services.partnerLoyalty.cardNumber');

type setCardNumberType = (cardNumber: string | null) => void;

interface IPartnerLoyalty {
  partnerLoyaltyInfo: IPartnerLoyaltyInfo | null;
  setCardNumber: setCardNumberType;
  isMobile: boolean | undefined;
}

const PartnerLoyalty = (props: IPartnerLoyalty) => {
  const { partnerLoyaltyInfo, setCardNumber, isMobile } = props;
  const [inputCardNumber, setInputCardNumber] = React.useState('');

  if (!partnerLoyaltyInfo) {
    return null;
  }

  const handleChange = (e) => {
    const newCardNumber = removeSpaces(e.target.value);

    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(Number(newCardNumber))) {
      setInputCardNumber(formatInputText(newCardNumber));
    }
  };

  const handleSend = () => {
    setCardNumber(
      inputCardNumber.length ? removeSpaces(inputCardNumber) : null,
    );
  };

  const { title, color, logo, description } = partnerLoyaltyInfo;
  const placeholder = '000 000 000';
  return (
    <StyledWrapper className="checkout-service-block">
      <Title $isMobile={isMobile}>{title}</Title>
      <StyledContainer>
        <LoyaltyHeader color={color}>
          <StyledLogo src={logo} alt="Logo" />
        </LoyaltyHeader>
        <LoyaltyBody $isMobile={isMobile}>
          <StyledLabledInput
            label={
              <StyledLabel htmlFor="loyalty-card">{INPUT_LABEL}</StyledLabel>
            }
            value={inputCardNumber}
            placeholder={placeholder}
            onChange={handleChange}
            onBlur={handleSend}
            size={40}
            id="loyalty-card"
            $isMobile={isMobile}
          />
          <PartnerProgramText $isMobile={isMobile}>
            {description}
          </PartnerProgramText>
        </LoyaltyBody>
      </StyledContainer>
    </StyledWrapper>
  );
};

const removeSpaces = (str: string) => str.replaceAll(' ', '');

// Добавление пробелов каждые 3 символа, кроме последней тройки
// Для карты S7
const formatInputText = (cardNumber: string) =>
  cardNumber.replace(/(.{3})/g, '$1 ').trim();

const StyledWrapper = styled.div<{ $isMobile?: boolean }>`
  margin-top: ${({ $isMobile }) => ($isMobile ? '16px' : '30px')};
`;

const Title = styled.h2<{ $isMobile?: boolean }>`
  margin-left: 8px;
  color: #17181a;
  font-size: ${({ $isMobile }) => ($isMobile ? '18px' : '26px')};
  line-height: ${({ $isMobile }) => ($isMobile ? '22px' : '26px')};
  margin-bottom: ${({ $isMobile }) => ($isMobile ? '8px' : '16px')};
`;

const StyledContainer = styled.div`
  box-shadow: 0px 1px 2px rgba(210, 208, 197, 0.9),
    0px 10px 15px rgba(216, 214, 204, 0.9);
  overflow: hidden;
  border-radius: 6px;
`;

const LoyaltyHeader = styled.div`
  height: 70px;
  background: ${({ color }) => color || '#fff'};
  display: flex;
  align-items: center;
`;

const LoyaltyBody = styled.div<{ $isMobile?: boolean }>`
  background: #fff;
  padding: ${({ $isMobile }) => ($isMobile ? '8px' : '16px')};
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  justify-content: space-between;
  align-items: center;
  column-gap: 48px;
  row-gap: 8px;
`;

const StyledLogo = styled.img`
  margin-left: 14.01px;
  vertical-align: middle;
  max-height: 70px;
  width: auto;
`;

const StyledLabledInput = styled(LabledInput)<{ $isMobile?: boolean }>`
  margin-bottom: ${({ $isMobile }) => ($isMobile ? '8px' : '20px')};
  flex-grow: 0;
  input {
    font-size: 14px;
    line-height: 16px;
    padding: 12px 8px;
  }
`;

const StyledLabel = styled.label`
  display: block;
  margin-left: 2px;
  margin-bottom: 6px;
  color: #4d4d4d;
`;

const PartnerProgramText = styled.div<{ $isMobile?: boolean }>`
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${({ $isMobile }) => ($isMobile ? '#17181a' : '#4d4d4d')};
`;

export default PartnerLoyalty;
